import(/* webpackMode: "eager", webpackExports: ["PrivacyContent"] */ "/var/www/server-service/web/app/(store)/(booking)/(with-footer)/(simple)/privacy/content.tsx");
